import { render, staticRenderFns } from "./ClientGuidesMenu.vue?vue&type=template&id=484211f6"
import script from "./ClientGuidesMenu.vue?vue&type=script&lang=js"
export * from "./ClientGuidesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports